import { render, staticRenderFns } from "./SectionForm.vue?vue&type=template&id=e0c9783c&"
import script from "./SectionForm.vue?vue&type=script&lang=js&"
export * from "./SectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports